import { useI18n } from "../../i18n/LanguageProvider";
import { Container, SectionLabel } from "../Container";
import { Reveal } from "../Reveal";
import { ArrowUpRight } from "lucide-react";

const AUDIENCE_IMG =
  "https://images.unsplash.com/photo-1590839823121-c253bf8d1e7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx2ZXRlcmluYXJpYW4lMjB3aXRoJTIwaG9yc2V8ZW58MHx8fHwxNzg1NDQ0NzA2fDA&ixlib=rb-4.1.0&q=85";

export function Audience() {
  const { t } = useI18n();
  const roles = t("audience.roles");

  return (
    <section className="py-32 md:py-40">
      <Container>
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
          <div>
            <SectionLabel>{t("audience.label")}</SectionLabel>
            <Reveal>
              <h2 className="text-3xl font-semibold leading-tight tracking-tight text-black sm:text-4xl lg:text-5xl">
                {t("audience.title")}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg leading-relaxed text-black/55">{t("audience.subtitle")}</p>
            </Reveal>

            <div className="mt-10 flex flex-wrap gap-3">
              {roles.map((role, i) => (
                <Reveal key={role} delay={0.15 + i * 0.05}>
                  <span className="inline-flex items-center gap-2 rounded-full border border-black/10 px-5 py-2.5 text-sm font-medium text-black transition-colors duration-200 hover:border-green hover:text-green">
                    {role}
                  </span>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.4}>
              <p className="mt-8 flex items-center gap-2 text-base text-black/45">
                <ArrowUpRight strokeWidth={1.5} className="h-4 w-4 text-green" />
                {t("audience.note")}
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="relative overflow-hidden rounded-3xl">
              <img
                src={AUDIENCE_IMG}
                alt={t("audience.title")}
                loading="lazy"
                className="aspect-[4/5] w-full object-cover grayscale transition-[filter] duration-700 hover:grayscale-0"
              />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10" />
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
